import WalletSelect from "@/features/wallet-select";
import TpSlProfileModalWithBtn from "../token-v2/modules/tp-sl-profiles/tp-sl-profile-modal-with-btn";
// import { SectionHeaderToggleButton } from "@/ui/SectionHeaderToggleButton";
// import { useState } from "react";

// const timeframes = ["1W", "1M", "1Y", "ALL"];

const PortfolioHeader = () => {
  // const [selectedTimeframe, setSelectedTimeframe] = useState("ALL");

  return (
    <div className="flex items-center justify-between p-[0.625rem]">
      <WalletSelect />
      {/* <div className="flex gap-x-[1.563rem] items-center"> */}
      {/* <div className="flex gap-x-[1.563rem] opacity-0">
          {timeframes.map((timeframe) => (
            <SectionHeaderToggleButton
              key={timeframe}
              title={timeframe}
              disabled
              active={selectedTimeframe === timeframe}
              onClick={() => setSelectedTimeframe(timeframe)}
            />
          ))}
        </div> */}
      {/* </div> */}
      <div className="absolute left-1/2 transform -translate-x-1/2 text-base leading-[0.625rem] font-semibold">
        Portfolio
      </div>
      <div className="h-[1.5rem]">
        <TpSlProfileModalWithBtn />
      </div>
    </div>
  );
};

export default PortfolioHeader;
